import { Button } from "../Button";
import { Modal } from "./Modal";

interface ConfirmationModalProps {
  id?: string;
  className?: string;
  isOpen: boolean;
  title: string;
  titleClassName?: string;
  description?: string | React.ReactNode;
  descriptionClassName?: string;
  warningText?: string;
  warningTextClassName?: string;
  icon?: string;
  blurColor?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export function ConfirmationModal({
  id,
  className,
  isOpen,
  title,
  titleClassName,
  description,
  descriptionClassName,
  warningText,
  warningTextClassName,
  icon,
  blurColor = "bg-[#FFE6CC]",
  confirmText = "Yes",
  cancelText = "No",
  onConfirm,
  onCancel,
}: ConfirmationModalProps) {
  if (!isOpen) return null;

  return (
    <Modal
      id={id}
      className={className}
      imgSrc={icon}
      isOpen={isOpen}
      showImg={!!icon}
      imgBlurColor={blurColor}
      onClose={onCancel}
    >
      <h2
        className={`mt-2 text-lg font-semibold text-[#111111] ${titleClassName}`}
      >
        {title}
      </h2>

      {description && (
        typeof description === "string" ? (
          <p className={`mt-2 text-md text-[#111111] ${descriptionClassName}`}>
            {description}
          </p>
        ) : (
          description
        )
      )}

      {warningText && (
        <p className={`mt-2 text-sm text-red-500 ${warningTextClassName}`}>
          {warningText}
        </p>
      )}

      <div className="mt-6 flex gap-4 justify-center">
        {onCancel && cancelText && (
          <Button
            onClick={onCancel}
            className="w-full rounded-lg bg-[#EDEDED] py-3 font-semibold text-[#111]"
          >
            {cancelText}
          </Button>
        )}

        {onConfirm && (
          <Button
            onClick={onConfirm}
            className="w-full rounded-lg bg-black py-3 font-semibold text-white"
          >
            {confirmText}
          </Button>
        )}
      </div>
    </Modal>
  );
}
